/* ROUND 76 -- IL CURSORE DORATO, PIU' VELOCE E SENZA SCATTI.
 *
 * Prima l'anello lo disegnava assets/motion.js (minificato). La titolare il
 * 6 ottobre 2026: "il cursore si bugga e va lento, che si stacchi di meno".
 * Misurato in Chromium a 1280 px con un giro veloce del mouse: il pallino
 * stava sul puntatore, l'anello 30 px indietro in media e fino a 46. Le
 * cause, lette nel file:
 *   - l'anello inseguiva con un passo fisso di 0,26 a fotogramma: circa 55 ms
 *     di ritardo, e di piu' quando un fotogramma salta;
 *   - sui link lo spostamento di centratura passava subito da 19 a 29 px
 *     mentre la larghezza cresceva in 0,3 s: per 300 ms l'anello stava fuori
 *     centro (sulle immagini da 19 a 38);
 *   - partiva dal centro dello schermo, restava fermo sugli iframe, e dopo la
 *     rotella diceva ancora "sopra un link" su quello che non c'era piu';
 *   - girava a ogni fotogramma anche a mouse fermo.
 *
 * Qui: stessi elementi e stesse classi (.cursor-ring, .cursor-dot,
 * html.cursor-on, is-link, is-media), quindi lo stile di base.css resta.
 * theme.liquid passa cursorRing:false a motion.js, che cosi' non crea il suo.
 *   - inseguimento A TEMPO (costante TAU): stessa distanza a 60 o 144 Hz e
 *     anche quando un fotogramma salta, e circa quattro volte piu' vicino;
 *   - il pallino si sposta nell'evento del mouse, non nel ciclo dei
 *     fotogrammi: e' il cursore, non deve mai restare indietro;
 *   - centratura con translate(-50%,-50%): l'anello resta centrato mentre si
 *     allarga, qualunque sia la sua misura in quel momento;
 *   - compare al primo movimento, sparisce fuori pagina e sugli iframe, e
 *     dove serve il cursore di sistema (campi di testo, menu a tendina, tela
 *     dell'editor): li' toglie html.cursor-on e tornano i cursori veri;
 *   - si ferma quando ha raggiunto il pallino.
 */
(function (root) {
  'use strict';

  // Millisecondi: in TAU l'anello copre il 63% della distanza dal puntatore.
  // Prima, col passo fisso 0,26 a 60 Hz, era circa 55.
  var TAU = 12;

  function passo(da, a, dt) {
    var t = Math.max(0, Math.min(dt, 64));
    return da + (a - da) * (1 - Math.exp(-t / TAU));
  }

  root.PerlaCursore = { TAU: TAU, passo: passo };
  if (typeof document === 'undefined' || typeof root.matchMedia !== 'function') return;

  var P = root.Perla || {};
  if (!P.perlaCursore || P.animations === false) return;
  if (!root.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (root.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.querySelector('.cursor-ring')) return;

  var html = document.documentElement;
  var LINK = 'a,button,[role="button"],.variant-pill,[data-tilt],label,summary';
  var MEDIA = '.card__media,.frame,[data-blinds],img';
  // Dove serve precisione o il cursore del testo, decide il sistema.
  var SISTEMA = 'input,textarea,select,[contenteditable="true"],.canvas-container,.photo-studio__frame';

  var ring = document.createElement('div');
  var dot = document.createElement('div');
  ring.className = 'cursor-ring';
  dot.className = 'cursor-dot';
  ring.setAttribute('aria-hidden', 'true');
  dot.setAttribute('aria-hidden', 'true');
  document.body.appendChild(ring);
  document.body.appendChild(dot);

  var mx = 0, my = 0, rx = 0, ry = 0;
  var ultimo = 0, rif = 0, visto = false, dentro = false, sistema = false;

  function classe(el, nome, si) {
    if (el.classList.contains(nome) !== si) el.classList.toggle(nome, si);
  }

  function aggiorna() {
    classe(html, 'cursor-on', dentro && !sistema);
  }

  function disegna(t) {
    rif = 0;
    var dt = ultimo ? t - ultimo : 16.7;
    ultimo = t;
    rx = passo(rx, mx, dt);
    ry = passo(ry, my, dt);
    if (Math.abs(mx - rx) < 0.3 && Math.abs(my - ry) < 0.3) { rx = mx; ry = my; }
    ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0) translate(-50%,-50%)';
    if (rx !== mx || ry !== my) rif = requestAnimationFrame(disegna);
    else ultimo = 0;
  }

  function avvia() {
    if (!rif) rif = requestAnimationFrame(disegna);
  }

  function stato(el) {
    if (!el || !el.closest) return;
    sistema = !!el.closest(SISTEMA);
    var link = el.closest(LINK), media = el.closest(MEDIA);
    classe(ring, 'is-link', !!link && !media);
    classe(ring, 'is-media', !!media && !link);
    aggiorna();
  }

  root.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    mx = e.clientX;
    my = e.clientY;
    dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0) translate(-50%,-50%)';
    if (!visto) { visto = true; rx = mx; ry = my; }
    dentro = true;
    stato(e.target);
    avvia();
  }, { passive: true });

  // Uscita dalla finestra (relatedTarget nullo) o ingresso in un iframe: li'
  // il documento non riceve piu' il movimento, e l'anello resterebbe fermo
  // sul bordo accanto al cursore di sistema.
  document.addEventListener('mouseout', function (e) {
    var verso = e.relatedTarget;
    if (!verso || verso.nodeName === 'IFRAME') { dentro = false; aggiorna(); }
  }, true);

  root.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') ring.classList.add('is-down');
  }, { passive: true });
  root.addEventListener('pointerup', function () {
    ring.classList.remove('is-down');
  }, { passive: true });

  // Con la rotella la pagina scorre sotto un mouse fermo: si ricontrolla cosa
  // c'e' sotto il puntatore finche' lo scorrimento morbido di motion.js si
  // assesta (circa 0,7 s), poi ci si ferma.
  var fino = 0, controllo = 0;
  function ricontrolla(t) {
    controllo = 0;
    stato(document.elementFromPoint(mx, my));
    if (t < fino) controllo = requestAnimationFrame(ricontrolla);
  }
  root.addEventListener('scroll', function () {
    if (!visto) return;
    fino = performance.now() + 700;
    if (!controllo) controllo = requestAnimationFrame(ricontrolla);
  }, { passive: true });
})(typeof window !== 'undefined' ? window : globalThis);
